var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('curve-editor', { ref: "curveDialog", attrs: { "width": "62", "height": "62", "initCurveValue": _vm.initCurveValue }, on: { "save": _vm.curveEdit } });
};
var staticRenderFns = [];

export { render, staticRenderFns };